<template>
<w-settings-content-template>
  <div slot="content">
    <el-tabs v-show="selectedNetdevice == null && !showRegistMagicianFlag" class="content-tap" type="card" v-model="activeTab">
      <el-tab-pane label="관리대상 등록" name="WNetdevice" class="h100 w100">
        <w-netdevice ref="WNetdevice" @select-netdevice="selectNetdevice" @click-regist-magician-button="clickRegistMagicianButton"></w-netdevice>
      </el-tab-pane>
      <el-tab-pane label="모델링 스케줄" name="WSchedule" class="h100 w100">
        <w-schedule ref="WSchedule" @update-modeling-schedule="updateModelingSchedule"></w-schedule>
      </el-tab-pane>
      <el-tab-pane label="모델링 방식" name="WModeling" class="h100 w100">
        <w-modeling ref="WModeling"></w-modeling>
      </el-tab-pane>
    </el-tabs>
    <w-netinterface v-show="selectedNetdevice != null" :selected-netdevice="selectedNetdevice" @click-back-button="clickBackButton"></w-netinterface>
    <w-regist-magician v-if="showRegistMagicianFlag" @click-back-button="clickBackButton" :regist-magician-info="registMagicianInfo"></w-regist-magician>
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WNetdevice from './Netdevice';
import WSchedule from './Schedule';
import WModeling from './Modeling';
import WNetinterface from './components/Netinterface';
import WRegistMagician from './components/RegistMagician';

export default {
  name: 'WNetwork',
  components: {
    WSettingsContentTemplate,
    WNetdevice,
    WSchedule,
    WModeling,
    WNetinterface,
    WRegistMagician,
  },
  props: {
    title: String,
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(value) {
        this.$nextTick(() => {
          this.$refs[value].loadData();
        });
      },
    },
  },
  data() {
    return {
      activeTab: 'WNetdevice',
      selectedNetdevice: null,
      showRegistMagicianFlag: false,
      registMagicianInfo: null,
    };
  },
  methods: {
    selectNetdevice(row) {
      this.selectedNetdevice = row;
    },
    clickBackButton(load) {
      this.selectedNetdevice = null;
      this.showRegistMagicianFlag = false;
      this.registMagicianInfo = null;
      if (load) {
        this.$refs[this.activeTab].loadData();
      }
    },
    clickRegistMagicianButton() {
      this.showRegistMagicianFlag = true;
    },
    updateModelingSchedule(registMagicianInfo) {
      this.registMagicianInfo = registMagicianInfo;
      this.showRegistMagicianFlag = true;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/index.vue